import React, { FC, ReactElement, useState, useEffect } from "react";
import {
  Box,
  Link,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  Drawer,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { routes, loggedInRoutes } from "../../routes";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { Props } from "./Navbar.interface";
import SideBar from "../../components/SideBar/SideBar";
import URL  from "../../utils/constants";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import screenReaderOffBlueIcon from "../../assets/header/screen-reader-off-blue.svg";
import screenReaderOffWhiteIcon from "../../assets/header/screen-reader-off-white.svg";
import screenReaderOnWhiteIcon from "../../assets/header/screen-reader-on-white.svg";
import screenReaderOnBlueIcon from "../../assets/header/screen-reader-on-blue.svg";
import voiceRecognitionIcon from "../../assets/header/search-voice-recognition.svg";
import hamburger from "../../assets/header/hamburger.svg";

import searchIcon from "../../assets/header/search.svg";
import dropDown from "../../assets/drop_list.svg";
import "../../../src/App.scss";
import NavbarMobile from "./NavbarMobile";
import { languageWhite, wheelChairWhite } from "../../assets/Icons";
import ReadSpeakerReader from "../../lib/ReadSpeakerReader";
import "./navbar.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleHalfStroke } from "@fortawesome/free-solid-svg-icons";
import logoutUaePassUrl from "../../utils/logoutUAEUrlConstruct";
import constants from "../../utils/constants";
const Navbar: FC<Props> = ({ admin, profileClick,handleNotification }: Props): ReactElement => {
  const searchParams:any = new URLSearchParams(window.location.search)
  const stateParam = searchParams.get('Lang');
  const stateParamColor = searchParams.get('color');
  const stateParamContrast = searchParams.get('contrast');
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [drawer, setDrawer] = React.useState(false);
  const [list, setList] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const handleOpenNavMenu = (event: any) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleDrawer = () => {
    toggleMenu();
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleLogoutClick = async () => {
    const isUaePass=localStorage.getItem('isUaePass');
    if(isUaePass){
      await User?.uaeGetConfig();
      const uaePasslogoutURL = logoutUaePassUrl(User?.uaePassConfigDetails);
      window.open(uaePasslogoutURL, "_self");
    }
    User.logout();
    User?.removePoBoxData();
    localStorage.removeItem("hash");
    localStorage.removeItem("nocType");
    localStorage.removeItem('isUaePass');
  };

  const emptyFunction = () => {};

  const [posts, setPosts] = useState([]);

  const [fontSize, setFontSize] = useState(16);
  const [selectedFontSize, setFontSizeSelected] = useState("normal");

  const [color, setColor] = useState<number>(14);

  const [menu, setMenu] = useState<number>(14);
  const [menu1, setMenu1] = useState<boolean>(false);
  const [mouseEnter, setMouseEnter] = useState<boolean>(false);
  const [keyword, setKeyword] = useState("");
  const [selectedColor, setSelectedColor] = useState("#101E8E");
  const [reader, setReader] = useState<any>();
  const [backgroundColor, setBackgroundColor] = useState<string>("");
  const [selectedMenuItem, setSelectedMenuItem] = useState(
    localStorage.getItem("menuItem") || "about"
  );
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if(stateParam){
      defaultLanguage(stateParam)
    }
    if(stateParamColor){
      handleColorClick(`#${stateParamColor}`)
    }
    if(stateParamContrast=='yellow'){
      handleContrastClick("yellow", "blue")
    }
    if(stateParamContrast=='lime'){
      handleContrastClick("lime", "black")
    }
  }, []);
  const defaultLanguage=async(data:any)=>{
    localStorage.setItem("settingUplanguage", data);
    await General.getCodeLabels();
  }
  const addLanguage = async (data: any) => {
    localStorage.setItem("settingUplanguage", data);
    await General.getCodeLabels();
    window.location?.reload()
  };

  localStorage.setItem("LanguageChange", JSON.stringify(posts));
  localStorage.setItem("fontSizeLocal", fontSize.toString());
  localStorage.setItem("colorNum", color.toString());

  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleInputChange = (event: any) => {
    setKeyword(event.target.value);
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const handleSearch = () => {
    if (keyword.trim() !== "") {
      axios
        .get(
          `${URL.URL.BASE_URL_1}api/ASPCL/web/search?keyword=${keyword}&lang=en`
        )
        .then((response) => {
          window.open(
            `${URL.URL.CORPORATE_WEBSITE}searchresults/${keyword}`,
            "_blank"
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const handleClick = (e: any) => {
    localStorage.setItem("fontSize", `${e}rem`);
    General.handleAccessibility({ text: e, backGround: "" });
  };
  const handleColorClick = (e: any) => {
    console.log('rr',e)
    setSelectedColor(e);
    General.handleColorClick({ type: e,colorClass:e==="#62AA51"?"green":e==="#000000"?"black":null,textClass:e==="#62AA51"?"greenText":e==="#000000"?"blackText":null });

  };
  const handleReaderClick = (e: any) => {
    General.handleScreenReader({ type: e });
  };
  const handleContrastClick = (contrastColor: any, contrastBackground: any) => {
    General.handleContrast({ contrastColor, contrastBackground });
  };
  const loginRegisterHandler = (link: any) => {
    window.open(link, "_blank");
  };
 
  return (
    <Box
      sx={{
        paddingLeft: "1.25rem",
        width: "100%",
        height: "auto",
        backgroundColor: General.contrast.contrastColor?General.contrast.contrastColor:"primary.light",
        boxShadow: "rgb(17 17 26 / 10%) 0px 1px 0px;",
        zIndex: "999",
      }}
    >
      {General?.screenReader && <ReadSpeakerReader language={""} url={""} />}
      {isLargeScreen ? (
        <>
          <Container
            maxWidth={false}
            sx={{ margin: "0", padding: "0 !important" }}
          >
            <Toolbar disableGutters variant="dense">
              <Typography
                variant="h6"
                // noWrap
                sx={{
                  mr: 2,
                  display: { xs: "none", md: "flex", cursor: "pointer" },
                }}
              >
                <img
                  onClick={() =>
                    navigate(`${User.info.personId ? "/dashboard" : "/"}`)
                  }
                  src={logo}
                  alt=""
                />
              </Typography>

              <Typography
                variant="h6"
                // noWrap
                component="div"
                sx={{
                  flexGrow: 1,
                  display: { xs: "flex", md: "none", cursor: "pointer" },
                }}
              >
                <img onClick={() => navigate("/")} src={logo} alt="" />
              </Typography>

              <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    // minHeight: "64px",
                  }}
                >
                  {!User.info.userName && (
                    <div
                      className={`search-bar ${
                        General?.colorClass === "black"
                          ? "search-bar-black"
                          : General?.colorClass === "green"
                          ? "search-bar-green"
                          : ""  
                      }${General.contrast.contrastColor? General.contrast.contrastColor === 'yellow'?'search-bar-yellowContrast':'search-bar-blackContrast':"" }`}
                      style={{
                        backgroundColor: "",
                      }}
                    >
                      <div
                        className="menu"
                        style={{
                          backgroundColor: General.contrast.contrastBackground?General.contrast.contrastBackground? General.contrast.contrastBackground: "#101e8e":General?.ColorAss?General?.ColorAss:'',
                          color:General.contrast.contrastColor?General.contrast.contrastColor?General.contrast.contrastColor:"":"#62AA51"
                        }}
                      >
                        <div
                          className="input-container"
                          style={{
                            backgroundColor: "",
                          }}
                        >
                          <img
                            src={voiceRecognitionIcon}
                            className="voice-icon" alt="voice recognition"
                          />
                          <input
                            type="text"
                            className="input-field"
                            onChange={handleInputChange}
                            value={keyword}
                            onKeyDown={handleKeyDown}
                          />
                          <img
                            src={searchIcon}
                            className="search-icon"
                            onClick={handleSearch} alt="search"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className={`language-changer ${
                      General?.colorClass == "black"
                        ? "language-accessibility-black"
                        : General?.colorClass == "green"
                        ? "language-accessibility-green"
                        : ""
                    }${General.contrast.contrastColor?General.contrast.contrastColor === 'yellow'?'language-accessibility-yellowContrast':'language-accessibility-blackContrast':'' }`}
                    style={{
                      backgroundColor: "",
                    }}
                
                  >
                
                    <div
                      className="menu"
                      style={{
                        backgroundColor: General.contrast.contrastBackground?General.contrast.contrastBackground?General.contrast.contrastBackground : "#101e8e":General?.ColorAss?General?.ColorAss:'',
                        color:General.contrast.contrastColor?General.contrast.contrastColor:""
                      }}
                    >
                      <div className="en" onClick={() => addLanguage("en-US")}>
                        {(General?.codeLabels["cm_eng"]?.label !== undefined
                          ? General?.codeLabels["cm_eng"]?.label
                          : "English").toUpperCase()}
                      </div>
                      <div className="ar" onClick={() => addLanguage("ar")}>
                        {General?.codeLabels["cm_ar"]?.label !== undefined
                          ? General?.codeLabels["cm_ar"]?.label
                          : "Arabic"}
                      </div>
                      <div className="hi" onClick={() => addLanguage("hi")}>
                        {(General?.codeLabels["cm_hin"]?.label !== undefined
                          ? General?.codeLabels["cm_hin"]?.label
                          : "Hindi").toUpperCase()}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`settings ${
                      General?.colorClass === "black"
                        ? "setting-accessibility-black"
                        : General?.colorClass === "green"
                        ? "setting-accessibility-green"
                        : ""  
                    } ${General.contrast.contrastColor?General.contrast.contrastColor === 'yellow'?'setting-accessibility-yellowContrast':'setting-accessibility-blackContrast':''}`}
                    style={{
                      backgroundColor: "",
                    }}
                  >
                    <div
                      className="menu"
                      style={{
                        backgroundColor:General.contrast.contrastBackground? General.contrast.contrastBackground?General.contrast.contrastBackground : "#101e8e":General?.ColorAss?General?.ColorAss:'',
                        color:General.contrast.contrastColor?General.contrast.contrastColor:""
                      }}
                    >
                      <div className="customizer">
                        <div>
                          {" "}
                          {General?.codeLabels["cm_text_size"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_text_size"]?.label
                            : "TEXT SIZE"}
                        </div>
                        <div className="fontsize-btns">
                          <div
                            onClick={() => {
                              setFontSize(1);
                              setFontSizeSelected("small");
                              handleClick(0.75);
                            }}
                            className={
                              selectedFontSize === "small" ? "selected" : ""
                            }
                          >
                            A--
                          </div>
                          <div
                            onClick={() => {
                              setFontSize(2);
                              handleClick(0.85);
                              setFontSizeSelected("medium");
                            }}
                            className={
                              selectedFontSize === "medium" ? "selected" : ""
                            }
                          >
                            A-
                          </div>
                          <div
                            onClick={() => {
                              setFontSize(3);
                              handleClick(1);
                              setFontSizeSelected("normal");
                            }}
                            className={
                              selectedFontSize === "normal" ? "selected" : ""
                            }
                          >
                            A
                          </div>
                          <div
                            onClick={() => {
                              setFontSize(4);
                              handleClick(1.05);
                              setFontSizeSelected("large");
                            }}
                            className={
                              selectedFontSize === "large" ? "selected" : ""
                            }
                          >
                            A+
                          </div>
                          <div
                            onClick={() => {
                              setFontSize(5);
                              handleClick(1.1);
                              setFontSizeSelected("extra-large");
                            }}
                            className={
                              selectedFontSize === "extra-large"
                                ? "selected"
                                : ""
                            }
                          >
                            A++
                          </div>
                        </div>

                        <div>
                          {" "}
                          {General?.codeLabels["cm_color"]?.label !== undefined
                            ? General?.codeLabels["cm_color"]?.label
                            : "COLOR"}
                        </div>
                        <div className="background-changer-btns">
                          <div
                            onClick={() => handleColorClick("#101E8E")}
                            className={`${
                              selectedColor === "#101E8E" ? "selected" : "blue"
                            }`}
                          ></div>
                          <div
                            onClick={() => handleColorClick("#000000")}
                            className={`${
                              selectedColor === "#000000"
                                ? "selectedBlack"
                                : "black"
                            }`}
                          ></div>
                          <div
                            onClick={() => handleColorClick("#62AA51")}
                            className={`${
                              selectedColor === "#62AA51"
                                ? "selectedGreen"
                                : "green"
                            }`}
                          ></div>
                        </div>
                        <div>
                          {" "}
                          {General?.codeLabels["cm_reader"]?.label !== undefined
                            ? General?.codeLabels["cm_reader"]?.label
                            : "READER"}
                        </div>

                        <div className="screen-reader">
                          <div
                            onClick={() => {
                              setReader("1");
                              handleReaderClick(false);
                            }}
                            className={reader === "1" ? "selected" : ""}
                          >
                            <img
                              src={
                                reader === "1"
                                  ? screenReaderOffWhiteIcon
                                  : screenReaderOffBlueIcon
                              }
                              alt="off"
                            />
                            OFF
                          </div>
                          <div
                            onClick={() => {
                              setReader("2");
                              handleReaderClick(true);
                            }}
                            className={reader === "2" ? "selected" : ""}
                          >
                            <img
                              src={
                                reader === "2"
                                  ? screenReaderOnWhiteIcon
                                  : screenReaderOnBlueIcon
                              }
                              alt="on"
                            />
                            ON
                          </div>
                        </div>

                        <div>
                          {General?.codeLabels["cm_contrast"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_contrast"]?.label
                            : "COLOR CONTRAST"}
                        </div>
                        <div className="contrast">
                          <div className="default-cont">
                            <FontAwesomeIcon
                              icon={faCircleHalfStroke}
                              style={{ color: "" }}
                              onClick={() => handleContrastClick("", "")}
                            />
                          </div>
                          <div className="yellow-cont">
                            <FontAwesomeIcon
                              icon={faCircleHalfStroke}
                              style={{ color: "#ff0" }}
                              onClick={() =>
                                handleContrastClick("yellow", "blue")
                              }
                            />
                          </div>
                          <div className="green-cont">
                            <FontAwesomeIcon
                              icon={faCircleHalfStroke}
                              style={{ color: "lime" }}
                              onClick={() =>
                                handleContrastClick("lime", "black")
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!User?.info?.userName && (
                    <>
                      <div
                        style={{
                          background: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            :ColorAss!='#101E8E'?ColorAss: "#62aa51",
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "white",
                        }}
                        className="quick-play"
                        onClick={() =>
                          loginRegisterHandler(
                            `${URL.URL.CORPORATE_WEBSITE}quickpay`
                          )
                        }
                      >
                        {General?.codeLabels["cm_payafriend"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payafriend"]?.label.toUpperCase()
                          : "Quick Pay"}
                      </div>
                      <div
                        style={{
                          background: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            :ColorAss!='#101E8E'?ColorAss: "#62aa51",
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "white",
                        }}
                        className="e-token"
                        onClick={() =>
                          loginRegisterHandler(
                            `${constants.URL.CORPORATE_WEBSITE}etoken`
                          )
                        }
                      >
                        {General?.codeLabels["cm_eticket"]?.label !== undefined
                          ? General?.codeLabels["cm_eticket"]?.label.toUpperCase()
                          : "E-Token"}
                      </div>
                      <div
                        className="login-register"
                        style={{
                          paddingInline: "10px",
                          backgroundColor: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            :ColorAss?ColorAss: "",
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "white",
                          // position:'relative'
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          <div>
                            {" "}
                            {General?.codeLabels["cm_loginsignup"]?.label !==
                            undefined
                              ? General?.codeLabels["cm_loginsignup"]?.label.toUpperCase()
                              : "Login/Register"}
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              left: "40%",
                              bottom: "-17px",
                            }}
                          >
                            <img src={dropDown} />
                          </div>
                        </div>
                        <div
                          className="menu"
                          style={{
                            background: General.contrast.contrastBackground? General.contrast.contrastBackground?General.contrast.contrastBackground : "#101e8e":General?.ColorAss?General?.ColorAss:'',
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : "",
                          }}
                        >
                          <div
                            className="tenant-owner"
                            onClick={() => navigate("/")}
                          >
                            {General?.codeLabels["cm_login_tenant"]?.label !==
                            undefined
                              ? General?.codeLabels["cm_login_tenant"]?.label.toUpperCase()
                              : "Login as a Tenant / Owner"}
                          </div>
                          <div
                            className="consultant"
                            onClick={() =>
                              loginRegisterHandler(
                                `${URL.URL.CUSTOMER_PORTAL}`
                              )
                            }
                          >
                            {General?.codeLabels["cm_login_consultant"]
                              ?.label !== undefined
                              ? General?.codeLabels["cm_login_consultant"]
                                  ?.label.toUpperCase()
                              : "Login as a Consultant"}
                          </div>
                          <div
                            className="new-account"
                            onClick={() => navigate("/movein-registration")}
                          >
                            {General?.codeLabels["cm_new_account"]?.label !==
                            undefined
                              ? General?.codeLabels["cm_new_account"]?.label.toUpperCase()
                              : "Create New Account"}
                          </div>
                        </div>
                      </div>
                      <div
                        className="hamburger-menu mr-2"
                        onClick={handleDrawer}
                      >
                        <img src={hamburger} alt="Hamburger Menu" />
                      </div>

                      {drawer && (
                        // <SideBar
                        //   selectedMenuItem={selectedMenuItem}
                        //   setSelectedMenuItem={setSelectedMenuItem}
                        //   toggleMenu={toggleMenu}
                        // />
                        <></>
                      )}
                    </>
                  )}
                  {
                                     
                  !User.info.userName
                    ? routes.map((page, index) => <></>)
                    : loggedInRoutes.map((page, index) => (

                        <div
                          // className={index==Number(backgroundColor)?General?.colorClass:""}
                          className={
                            page?.key === "home-route" ? General?.contrast?.contrastColor : ""
                          }
                          key={index}
                          style={{
                            //borderRight: "1px white solid",
                            minHeight: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            display: "flex",
                            textAlign: "center",
                            backgroundColor: `${
                               General.contrast.contrastColor === 'yellow' ? '#0000FF' : (General.contrast.contrastColor === 'lime' ? '#000' : page?.backgroundColor) || "none"
                            }`,

                            // backgroundColor:page.backgroundColor ,
                            minWidth: page.width || "auto",
                          }}
                          onMouseOver={() => {
                            page.key === "wheelchair-route" && setList(true);
                            page.key === "language-route" && setMenu1(true);
                            // setBackgroundColor(String(index));
                          }}
                          onMouseOut={() => {
                            setList(false);
                            setMenu1(false);
                            setBackgroundColor("20");
                          }}
                        >
                          <Link
                            onClick={
                              page.key == "home-route"
                                ? profileClick
                                : page.key == "logout-route"
                                ? handleLogoutClick
                                : emptyFunction
                            }
                            component={NavLink}
                            to={"/dashboard"}
                            //color=background:General.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : ''),
                            color={General.contrast.contrastColor === 'yellow' ? '#FFFF00' : (General.contrast.contrastColor === 'lime' ? '#00FF00' : '')}
                            
                            underline="none"
                            variant="button"
                            sx={
                              page.title
                                ? {
                                    fontSize: `${
                                      0.875 * General.accessibility.fontSize
                                    }rem`,
                                    marginLeft: "2rem",
                                    marginRight: "2rem",
                                    fontWeight: 700,
                                    color: General?.contrast?.contrastColor?General?.contrast?.contrastColor: "none",
                                    display: "flex",
                                    flexDirection: "row",
                                    whiteSpace: "nowrap",
                                    gap: "20px",
                                    "&:hover": {
                                      color: "white",
                                      textDecoration: "none",
                                    },
                                  }
                                : {
                                    fontSize: `${
                                      0.875 * General.accessibility.fontSize
                                    }rem`,
                                    marginLeft: "2rem",
                                    marginRight: "2rem",
                                    fontWeight: 700,
                                    color: General?.contrast?.contrastColor?General?.contrast?.contrastColor: "none",
                                    display: "flex",
                                    flexDirection: "row",
                                    whiteSpace: "nowrap",
                                    gap: "20px",
                                    "&:hover": {
                                      color: "white",
                                      textDecoration: "none", // Remove underline on hover
                                    },
                                  }
                            }
                          >
                            {page.icon && (
                              <img src={General.contrast.contrastColor?page.iconWhite:page.icon} alt="profile" />
                          
                            )}

                            {page.title &&
                              (General?.codeLabels["cm_pdc_paymentaccounts"]
                                ?.languageCode == "ARA"
                                ? User?.profile?.arName
                                  ? User?.profile?.arName?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                                  : User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ')
                                : (User?.profile?.name?.trim()?.split(/[,\s]+/)?.slice(0, 3)?.join(' ') as string))}
                          </Link>
                        </div>
                      ))}
                </Box>
              </Box>

              <Box
                sx={{ display: { xs: "flex", md: "flex" } }}
                className="responsive-navbar"
                
              >
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="primary"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  {routes.map((page) => (
                    <Link
                      key={page.key}
                      component={NavLink}
                      to={page.path}
                      color="black"
                      underline="none"
                      variant="button"
                    >
                      <MenuItem onClick={handleCloseNavMenu}>
                        {page.icon && <img src={page.icon} alt="" />}
                        <Typography textAlign="center">{page.title}</Typography>
                      </MenuItem>
                    </Link>
                  ))}
                </Menu>
              </Box>
            </Toolbar>
          </Container>
          {menuOpen && (
            <SideBar
              selectedMenuItem={selectedMenuItem}
              setSelectedMenuItem={setSelectedMenuItem}
              toggleMenu={toggleMenu}
            />
          )}
        </>
      ) : (
        <>
          <NavbarMobile
            handleNotification={handleNotification}
            handleLogoutClick={handleLogoutClick}
            profileClick={() => {
              profileClick();
            }}
          />
        </>
      )}
    </Box>
  );
};

export default observer(Navbar);
